export default {
    forgot_password_username: 'Username',
    forgot_password_username_placeholder: 'Enter your username or email',
    forgot_password_have_a_code: 'I have a code',
    forgot_password_vefification_code: 'Verification Code',
    forgot_password_resend: 'Resend',
    forgot_password_dont_receive_the_code: "Don't receive the code?",
    forgot_password_new_password: "New Password",
    forgot_password_repeat_new_password: "Repeat New Password",
    forgot_password_password_recovery: "Password Recovery",
    forgot_password_verify_user: "Verify the user name entered and try again",
    forgot_password_the_password_has_been_changed: "The password has been changed. You can now log in",
    forgot_password_limit: "Attempt limit exceeded, please try after some time",
    forgot_password_message: "An email is going to be send to your email address with a link to reset your password",
    forgot_password_message_success: "An email has been sent to your email address with a link to reset your password",
};